import {load} from '@shopify/theme-sections';
import '../sections/blog-carousel';
import '../../styles/blog.scss';
import {lazyScript} from '../ui/lazy-script';
import BlogNavigation from '../ui/blog-navigation';

new BlogNavigation('[data-blog-nav]');

lazyScript();

load('*');
